import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ExceptionModule } from './modules/exception/exception.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpConfig } from './configs/http.config';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { HistoryComponent } from './modules/history/history.component';
import { PasswordModule } from 'primeng/password';
import { OtpVerificationComponent } from './shareds/otp-verification/otp-verification.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { PhoneInputModule } from 'src/app/shareds/phone-input/phone-input.module';
import { MarketingComponent } from './modules/marketing/marketing.component';
import { ContactComponent } from './modules/contact/contact.component';
import { BillingComponent } from './modules/billing/billing.component';
import { RoleComponent } from './modules/role/role.component';
import { ProcurementComponent } from './modules/procurement/procurement.component';
import { AccountingComponent } from './modules/accounting/accounting.component';
import { InvventoryComponent } from './modules/invventory/invventory.component';
import { DecimalPipe } from '@angular/common';












@NgModule({ declarations: [
        AppComponent,
        HistoryComponent,
        OtpVerificationComponent,
        MarketingComponent,
        ContactComponent,
        BillingComponent,
        RoleComponent,
        AccountingComponent,
        ProcurementComponent,
        InvventoryComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ExceptionModule,
        ToastModule,
        ButtonModule,
        DialogModule,
        ConfirmDialogModule,
        NgOtpInputModule,
        PhoneInputModule,
        PasswordModule], providers: [
        MessageService,
        ConfirmationService,
        providePrimeNG({
            // ปิด dark mode ของ Aura (ค่าเริ่มต้นตาม prefers-color-scheme ทำให้ card/table เป็นสีดำ)
            theme: { preset: Aura, options: { darkModeSelector: false } },
            ripple: true,
            translation: {
                dayNames: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
                dayNamesShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
                dayNamesMin: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                monthNames: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                monthNamesShort: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
                today: 'วันนี้',
                clear: 'ล้าง',
                chooseYear: 'เลือกปี',
                chooseMonth: 'เลือกเดือน',
                chooseDate: 'เลือกวันที่',
                weekHeader: 'สัปดาห์',
            },
        }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfig,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
